module.exports = __webpack_public_path__ + "static/media/etiqaLogoChanged.fdeea2bc.png";